export const NavigationItems = [
  {name: '#Intro', href: '#intro'},
  {name: '#Burnout', href: '#burnout'},
  {name: '#Services', href: '#services'},
  {name: '#Payments', href: '#payments'},
  {name: '#Contact', href: '#contact'},
];
